import { adminData } from "~/admin/data";

export const PROPS_STATE_ID = adminData.PROPS_INTEGER_ID;
export const PROPS_STATE_NAME = adminData.PROPS_NAME;
export const PROPS_STATE_GUID = adminData.PROPS_ID;
export const PROPS_MODIFIED_DATE = "modifiedDate";
export const PROPS_STATE_ABBREVIATION = adminData.PROPS_STATE_ABBREVIATION;
export const PROPS_COUNTRY_NAME = "countryName";
export const PROPS_ACTIVE_YN = adminData.PROPS_IS_ACTIVE;
